export default "__VITE_PUBLIC_ASSET__17b6bd65__"